module.exports = __webpack_public_path__ + "static/media/school.0977da8c.png";